export default {
	spacing: 10,
	labelsWidth: 30,
	queryWaitTime: 500,
	defaultColumnWidth: 200,
};
